import { create } from 'zustand';

type AgentContext = 'hr' | 'employee' | 'recruitment' | 'project' | null;

interface SidebarFilterStore {
  activeAgent: AgentContext;
  setActiveAgent: (agent: AgentContext) => void;
  clearActiveAgent: () => void;
}

const useSidebarFilterStore = create<SidebarFilterStore>((set) => ({
  activeAgent: null,
  setActiveAgent: (agent) => set({ activeAgent: agent }),
  clearActiveAgent: () => set({ activeAgent: null }),
}));

export default useSidebarFilterStore;
